import { Box, Paper, Button, Typography } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import { supabase } from '../supabaseClient';
import logo from '../components/logo_black.png';

export default function LoginPage() {
  const handleInstagramLogin = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'facebook',
      options: {
        redirectTo: `https://dashboard.clozet.my/auth/callback`,
        scopes: 'instagram_basic,instagram_manage_messages,instagram_manage_comments,pages_show_list,pages_manage_metadata,pages_messaging,business_management',
      },
    });
  };

  return (
    <Box sx={{ width: '100vw', height: '100vh', bgcolor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper
        elevation={0}
        sx={{
          width: { xs: '100%', md: 900 },
          height: { xs: '100%', md: 480 },
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 2px 16px 0 rgba(30, 42, 50, 0.08)',
        }}
      >
        {/* Left */}
        <Box
          sx={{
            flex: 1,
            bgcolor: 'rgb(0,0,0)',
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            p: 5,
          }}
        >
          <img src={logo} alt="logo" style={{ height: 120, marginBottom: 36, userSelect: 'none', background: 'rgb(0,0,0)' }} draggable={false} />
          <Typography variant="h5" fontWeight={700} sx={{ mb: 2, textAlign: 'center' }}>
            Clozet 대시보드
          </Typography>
          <Typography sx={{ color: '#bbb', textAlign: 'center', fontSize: 16 }}>
            브랜드·크리에이터 전용 관리 플랫폼
          </Typography>
        </Box>

        {/* Right */}
        <Box
          sx={{
            flex: 1,
            bgcolor: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            p: 5,
            gap: 3,
          }}
        >
          <Typography variant="h6" fontWeight={700} sx={{ color: '#222', textAlign: 'center' }}>
            Instagram 비즈니스 계정으로 시작하기
          </Typography>
          <Typography sx={{ color: '#888', fontSize: 14, textAlign: 'center' }}>
            Instagram 비즈니스 계정 + Facebook 페이지가 필요합니다.
          </Typography>

          <Button
            onClick={handleInstagramLogin}
            fullWidth
            variant="contained"
            sx={{
              maxWidth: 320,
              py: 1.5,
              fontWeight: 700,
              fontSize: 15,
              borderRadius: 2,
              background: 'linear-gradient(135deg, #7c3aed, #db2777)',
              '&:hover': { background: 'linear-gradient(135deg, #6d28d9, #be185d)' },
              display: 'flex',
              gap: 1.5,
            }}
          >
            <InstagramIcon sx={{ fontSize: 20 }} />
            Instagram으로 로그인
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
